import React, { useState } from 'react';
import Typography from 'material-ui/Typography/Typography';
import WorkingMaxEdit from './WorkingMaxEdit';

const WorkingMaxValue = props => {
    const {
        userId,
        isLift,
        value,
        units,
        exerciseId,
        exerciseTitle,
        reload
    } = props;

    if (!isLift) {
        return null;
    }

    const displayText = value ? `${value} ${units}` : `No working max set`;

    return (
        <div className="workingMax">
            <WorkingMaxEdit
                userId={userId}
                exerciseTitle={exerciseTitle}
                exerciseId={exerciseId}
                workingMaxValue={value}
                workingMaxUnits={units}
                reload={reload}
            />
            <div className="title">WORKING MAX</div>
            <Typography variant="body2" className="value">
                {displayText}
            </Typography>
        </div>
    );
};

export default WorkingMaxValue;



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/components/WorkingMaxValue.jsx